<template>
  <v-menu offset-y>
    <template v-slot:activator="{ on }">
      <v-btn
        v-if="getAuthUserName"
        text
        small
        exact
        class="white"
        color="grey darken-3"
        v-on="on"
      >
        <v-icon left>mdi-account-circle</v-icon>

        {{ getAuthUserName }}
      </v-btn>
    </template>
    <v-list dense>
      <v-list-item
        v-if="getIsShopDead"
        link
        exact
        :to="{ name: ShopSettingsRoute, hash: '#subscription' }"
      >
        <v-list-item-title class="proxima--font font-weight-bold"
          >Subscribe</v-list-item-title
        >
      </v-list-item>
      <v-list-item
        v-else-if="isViewingFrontEnd"
        link
        exact
        :to="{ name: MerchantDashboardRoute }"
      >
        <v-list-item-title class="proxima--font font-weight-bold"
          >Dashboard</v-list-item-title
        >
      </v-list-item>
      <v-list-item
        v-if="!getIsShopDead"
        link
        exact
        :to="{ name: MerchantAccountRoute }"
      >
        <v-list-item-title class="proxima--font font-weight-bold"
          >Edit Account</v-list-item-title
        >
      </v-list-item>
      <v-list-item
        v-if="canSuperAdmin"
        link
        exact
        :to="{ name: SuperAdminDashboardRoute }"
      >
        <v-list-item-title class="proxima--font font-weight-bold"
          >Reports</v-list-item-title
        >
      </v-list-item>
      <v-list-item link @click="logoutHandler">
        <v-list-item-content>
          <v-list-item-title class="proxima--font font-weight-bold"
            >Logout</v-list-item-title
          >
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import _intersection from 'lodash/intersection'
import RouteNames from '@/constants/RouteNames'
import { ADMIN_URI_BASE, CUSTOMER_URI_BASE } from '@/constants/RouteNames'

export default {
  name: 'AdminAccountBtnDropdown',
  components: {},
  computed: {
    ...mapGetters('auth', ['getAuthUserName', 'canSuperAdmin']),
    ...mapGetters('shop', ['getIsShopDead']),
    isViewingFrontEnd() {
      return !_intersection(this.$route.path.split('/'), [
        ADMIN_URI_BASE,
        CUSTOMER_URI_BASE,
      ]).length
    }, // isViewingFrontEnd
  },
  methods: {
    ...mapActions('auth', ['logout']),
    async logoutHandler() {
      await this.logout()
      this.$router.push({
        name: RouteNames.Merchant.LOGIN,
        query: { loggedOut: true },
      })
    },
  },
  data() {
    return {
      MerchantAccountRoute: RouteNames.Merchant.Manage.ACCOUNT,
      MerchantDashboardRoute: RouteNames.Merchant.Manage.HOME,
      ShopSettingsRoute: RouteNames.Merchant.Manage.SHOP_SETTINGS,
      SuperAdminDashboardRoute: RouteNames.SuperAdmin.DASHBOARD,
    }
  },
}
</script>
